import styles from './Decision.module.css';
import openAnimation from '../../assets/openAnimation.gif';

const OpenDecision = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>
        Thank you!
        <span className={styles.headingSection}>
          We’re reviewing your application
        </span>
      </h1>
      <div className={styles.gifContainer}>
        <img data-testid="open-animation" src={openAnimation} alt="" />
      </div>
      <div className={styles.body}>
        <div className={styles.bodySection}>
          <h3 className={styles.bodyHeading}>What happens next?</h3>
          <p className={styles.bodyContent}>
            We’ll aim to email you with a decision within 24 hours - we’re
            receiving more applications than usual at the moment, so please bear
            with us if we take a little longer.
          </p>
        </div>
        <div className={styles.bodySection}>
          <h3 className={styles.bodyHeading}>Get in touch with iwoca</h3>
          <p className={styles.bodyContent}>
            Call us on{' '}
            <a href="tel:02037780105" target="_blank" rel="noreferrer">
              020 3778 0105
            </a>{' '}
            (Monday to Friday 9am - 6pm)
          </p>
          <p className={styles.bodyContent}>
            Email us at{' '}
            <a
              href="mailto:support@iwoca.co.uk"
              target="_blank"
              rel="noreferrer"
            >
              support@iwoca.co.uk
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OpenDecision;
